export const drawerScrollTop = (drawerId: string): void => {
  const element = document.querySelector(`#${drawerId} > .MuiPaper-elevation`);
  if (element) {
    element.scrollTop = 0;
  }
};
